import { type Component, Show } from 'solid-js'
import Icon from '~/components/Icon'
import { type ActivityType, activityLabel } from '~/utils/chat'

/**
 * Indicador de "el asistente está trabajando". Distingue pensar de ejecutar una
 * herramienta: una tool puede tardar y sin esto la burbuja se queda muda y
 * parece que se colgó.
 */
const ChatActivity: Component<{ activity: ActivityType }> = props => (
  <Show when={props.activity.state !== 'idle'}>
    <div class="flex items-center gap-2 text-sm text-foreground-subtle" aria-live="polite">
      <Show
        when={props.activity.state === 'tool'}
        fallback={
          <span class="flex gap-1" aria-hidden="true">
            <span class="w-1.5 h-1.5 rounded-full bg-current animate-bounce [animation-delay:-0.3s]" />
            <span class="w-1.5 h-1.5 rounded-full bg-current animate-bounce [animation-delay:-0.15s]" />
            <span class="w-1.5 h-1.5 rounded-full bg-current animate-bounce" />
          </span>
        }
      >
        <Icon icon="material-symbols-light:widgets-outline" size={16} class="animate-pulse" />
      </Show>
      <span>{activityLabel(props.activity)}</span>
    </div>
  </Show>
)

export default ChatActivity
